import React from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '300px'};
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid var(--glass-border);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  margin: ${props => props.align === 'center' ? '0 auto' : '0'};
`;

const GoogleMapsWidget = ({ node }) => {
  const address = encodeURIComponent(node.content?.address || 'Telefónica Germany, Georg-Brauchle-Ring 50, München');
  const zoom = node.content?.zoom || 14;

  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width} height={node.style?.desktop?.height}>
      <iframe 
        width="100%" 
        height="100%" 
        style={{ border: 0 }}
        loading="lazy" 
        allowFullScreen 
        src={`https://maps.google.com/maps?q=${address}&t=m&z=${zoom}&output=embed&iwloc=near`}
      ></iframe>
    </Wrapper>
  );
};

registry.register('google_maps', {
  label: 'Google Maps',
  icon: '🗺️',
  category: 'media',
  defaultContent: {},
  defaultStyle: { desktop: { align: 'center', width: '100%', height: '300px' } },
  render: GoogleMapsWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Adresse', fields: [{name:'content.address', label:'Adresse / Ort', type:'text'}, {name:'content.zoom', label:'Zoom Level (1-20)', type:'text'}] }] },
    { tab: 'style', groups: [{ title: 'Dimensionen', fields: [{name:'style.desktop.width', label:'Breite', type:'text'}, {name:'style.desktop.height', label:'Höhe', type:'text'}, {name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}] }] }
  ]
});
